import { observer } from 'mobx-react-lite'
import { DragAndDropOverlay } from '@/features/jobs/details/components/DragAndDropOverlay'
import type { UploadBarViewModel } from '@/features/documents/UploadBarViewModel'
import { type Job } from '@/features/jobs/Job'

export interface DragAndDropOverlayContainerProps {
  vm: UploadBarViewModel
  targetJob: Job
  onView?: () => void
}

export const DragAndDropOverlayContainer = observer(
  function DragAndDropOverlayContainer({
    vm,
    targetJob,
    onView,
  }: DragAndDropOverlayContainerProps) {
    return (
      <DragAndDropOverlay
        isHidden={vm.hidden}
        isDragging={vm.dragging}
        isUploading={vm.uploading}
        isResolved={vm.resolved}
        currentlyUploadingFileName={vm.currentlyUploadingFile?.name}
        remainingCount={vm.uploadQueueFiles.length}
        successUploadCount={vm.successUploads.length}
        firstSuccessUploadName={vm.successUploads[0]?.file.name}
        targetJobDisplayName={targetJob.displayName}
        onView={onView}
      />
    )
  },
)
